import { FC, PropsWithChildren, useRef } from 'react';

import { ApplicationConfig, useApplication } from '@bonusly/application';
import { joinPath } from '@bonusly/http';

import { useHttpStore } from '../hooks/use-http-store';
import { createHttpClient } from '../lib/create-http-client';

type HttpClientProviderProps = PropsWithChildren<{ onUnauthorized?: () => void }>;

export const HttpClientProvider: FC<HttpClientProviderProps> = ({ children, onUnauthorized }) => {
	const initRef = useRef(false);
	const { application } = useApplication();

	if (!initRef.current) {
		const createClient = (baseURLEnv: keyof ApplicationConfig, path: string) => {
			const origin = application.get(baseURLEnv, { allowEmpty: true });

			if (!origin) {
				return null;
			}

			return createHttpClient(joinPath(origin, path), { onUnauthorized });
		};

		useHttpStore.setState({
			data: createClient('recognizeOrigin', '/api/v1/data_layer'),
			rcs: createClient('recognizeOrigin', '/api/v1/rewards_catalog_service/api/v1'),
			v1: createClient('recognizeOrigin', '/api/v1'),
			v2: createClient('recognizeOrigin', '/api/v2'),
		});

		initRef.current = true;
	}

	return <>{children}</>;
};
